import {
  fileSchema,
  type ApiProcessIndividualResponseSchema,
  type ApiProcessResponseSchema,
  type newProcessSchema,
  type processSchema,
} from "@/schemas/processes";
import { z } from "zod";

export const processStatusEnum = {
  active: "PUBLISHED",
  inactive: "INACTIVE",
  onConstruction: "ON_CONSTRUCTION",
} as const;

export type ProcessStatusType =
  (typeof processStatusEnum)[keyof typeof processStatusEnum];

type ProcessRelationshipsType = "createdBy" | "flows" | "tags" | "files";

export type ProcessFiltersType = {
  filter?: { [key: string]: string };
  order_by?: string;
  page?: number;
  per_page?: number;
  relationships: ProcessRelationshipsType[];
};

export type ProcessType = z.infer<typeof processSchema>;
export type ProcessTypeResponse = { data: ProcessType };

export type ApiIndividualProcessResponseType = z.infer<
  typeof ApiProcessIndividualResponseSchema
>;

export type ApiProcessResponseType = z.infer<typeof ApiProcessResponseSchema>;

export type StoreProcessData = z.infer<typeof newProcessSchema>;

export type ProcessFileType = z.infer<typeof fileSchema>;
